<template>
  <button
    :title="title"
    :class="`btn text-white border-0 custom-pointer btn-radius ${
      btnName != '' ? '' : 'akkurate-small'
    } ${classes}`"
    @click="() => func()"
    :disabled="disabled"
  >
    <font-awesome-icon v-if="icon != ''" :icon="['fas', icon]" />
    <span v-if="btnName" class="ms-2">{{ btnName }}</span>
  </button>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  name: "Suppliers",
  props: {
    func: {
      type: Function,
      default: null,
      required: true,
    },
    classes: {
      type: String,
      default: "",
      required: false,
    },
    icon: {
      type: String,
      default: "",
      required: false,
    },
    btnName: {
      type: String,
      default: "",
      required: false,
    },
    title: {
      type: String,
      default: "",
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
